<template>
  <span class="icon">
    <svg
      class="folder-config"
      width="32"
      height="24"
      viewBox="-2 -1 24 18"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink">
      <!-- Generator: Sketch 55.2 (78181) - https://sketchapp.com -->
      <title>Folder Config</title>
      <desc>A folder with a cog icon on top</desc>
      <g
        id="Page-1"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd">
        <g
          id="folder-24px"
          transform="translate(-2.000000, -4.000000)">
          <path
            id="Combined-Shape"
            d="M10,4 L12,6 L20,6 C21.1,6 22,6.9 22,8 L22,18 C22,19.1 21.1,20 20,20 L4,20 C2.9,20 2,19.1 2,18 L2.01,6 C2.01,4.9 2.9,4 4,4 L10,4 Z M18.9407795,12.940625 C18.9600556,12.8 18.9696936,12.6546875 18.9696936,12.5 C18.9696936,12.35 18.9600556,12.2 18.9359605,12.059375 L19.9142213,11.31875 C20.0009636,11.253125 20.0250587,11.1265625 19.9720495,11.0328125 L19.0467979,9.4765625 C18.9889697,9.3734375 18.8684942,9.340625 18.7624758,9.3734375 L17.6107303,9.8234375 C17.3697793,9.6453125 17.1143713,9.4953125 16.8300492,9.3828125 L16.6565645,8.1921875 C16.6372885,8.0796875 16.5409081,8 16.4252516,8 L14.5747484,8 C14.4590919,8 14.3675306,8.0796875 14.3482545,8.1921875 L14.1747698,9.3828125 C13.8904477,9.4953125 13.6302207,9.65 13.3940887,9.8234375 L12.2423432,9.3734375 C12.1363248,9.3359375 12.0158493,9.3734375 11.9580211,9.4765625 L11.0375885,11.0328125 C10.9797603,11.13125 10.9990364,11.253125 11.0954167,11.31875 L12.0736776,12.059375 C12.0495825,12.2 12.0303064,12.3546875 12.0303064,12.5 C12.0303064,12.6453125 12.0399444,12.8 12.0640395,12.940625 L11.0857787,13.68125 C10.9990364,13.746875 10.9749413,13.8734375 11.0279505,13.9671875 L11.9532021,15.5234375 C12.0110303,15.6265625 12.1315058,15.659375 12.2375242,15.6265625 L13.3892697,15.1765625 C13.6302207,15.3546875 13.8856287,15.5046875 14.1699508,15.6171875 L14.3434355,16.8078125 C14.3675306,16.9203125 14.4590919,17 14.5747484,17 L16.4252516,17 C16.5409081,17 16.6372885,16.9203125 16.6517455,16.8078125 L16.8252302,15.6171875 C17.1095523,15.5046875 17.3697793,15.3546875 17.6059113,15.1765625 L18.7576568,15.6265625 C18.8636752,15.6640625 18.9841507,15.6265625 19.0419789,15.5234375 L19.9672305,13.9671875 C20.0250587,13.8640625 20.0009636,13.746875 19.9094023,13.68125 L18.9407795,12.940625 Z M15.5,14.1875 C14.5458343,14.1875 13.7651532,13.428125 13.7651532,12.5 C13.7651532,11.571875 14.5458343,10.8125 15.5,10.8125 C16.4541657,10.8125 17.2348468,11.571875 17.2348468,12.5 C17.2348468,13.428125 16.4541657,14.1875 15.5,14.1875 Z"
            fill="currentColor"
            fill-rule="nonzero"/>
          <polygon
            id="Path"
            points="0 0 24 0 24 24 0 24"/>
        </g>
      </g>
    </svg>
  </span>
</template>

<style lang="scss" scoped>
  .icon {
    display: inline-block;

    .folder-config {
      display: block;
      width: 1em;
      height: 1em;
      fill: currentColor;
    }
  }
</style>
